import Alpine from 'alpinejs';

interface ListboxTabSwitchState {
    $el: HTMLElement;
    switchTab: (index: string) => void;
}

export function registerListboxTabSwitch(): void {
    Alpine.data('listboxTabSwitch', (): ListboxTabSwitchState => ({
        $el: {} as HTMLElement,

        switchTab(index: string): void {
            const container = this.$el.parentElement?.querySelector('[data-tabs="container"]');

            if (!container) {
                return;
            }

            const triggers = container.querySelectorAll<HTMLElement>('[data-tabs="trigger"]');
            const trigger = triggers[parseInt(index)];

            if (trigger) {
                trigger.click();
            }
        },
    }));
}
